export default function (initialDataInteractor) {
  let newPeopleArray = [];

  initialDataInteractor.data.people.forEach(function (person) {
    let newPerson = {};
    Object.assign(newPerson, person);

    newPeopleArray.push(newPerson);
  });

  return newPeopleArray;
}